import React from 'react';

const Tennis = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12549_37577)" }, /* @__PURE__ */ React.createElement(
    "circle",
    {
      cx: "10.0045",
      cy: "10.0021",
      r: "8.54373",
      transform: "rotate(30 10.0045 10.0021)",
      stroke: "white",
      strokeWidth: "1.2503"
    }
  ), /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "mask0_12549_37577",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "20",
      height: "20"
    },
    /* @__PURE__ */ React.createElement(
      "circle",
      {
        cx: "10.0048",
        cy: "10.0023",
        r: "8.33535",
        fill: "#D9D9D9",
        stroke: "white",
        strokeWidth: "1.66707"
      }
    )
  ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_12549_37577)" }, /* @__PURE__ */ React.createElement(
    "circle",
    {
      cx: "-2.26774",
      cy: "2.917",
      r: "11.0443",
      transform: "rotate(30 -2.26774 2.917)",
      stroke: "white",
      strokeWidth: "1.2503"
    }
  ), /* @__PURE__ */ React.createElement(
    "circle",
    {
      cx: "22.2791",
      cy: "17.0872",
      r: "11.0443",
      transform: "rotate(30 22.2791 17.0872)",
      stroke: "white",
      strokeWidth: "1.2503"
    }
  ))),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12549_37577" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { Tennis };
//# sourceMappingURL=Tennis.js.map
